var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","md":"12"}},[_c('FacilityList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }